/**
 * Página de Faturas
 */

import { FileText, Download, QrCode, Barcode } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { PageHeader } from '@/components/shared/PageHeader';
import { StatusBadge } from '@/components/shared/StatusBadge';
import { mockInvoices } from '@/mocks/data';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { toast } from 'sonner';

export default function InvoicesPage() {
  return (
    <div>
      <PageHeader title="Faturas" description="Histórico de faturas e pagamentos" />

      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Período</TableHead>
              <TableHead>Valor</TableHead>
              <TableHead>Vencimento</TableHead>
              <TableHead>Status</TableHead>
              <TableHead className="text-right">Ações</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {mockInvoices.map(inv => (
              <TableRow key={inv.id}>
                <TableCell className="text-sm">
                  {new Date(inv.period_start).toLocaleDateString('pt-BR')} — {new Date(inv.period_end).toLocaleDateString('pt-BR')}
                </TableCell>
                <TableCell className="text-sm font-medium">R$ {inv.amount.toFixed(2)}</TableCell>
                <TableCell className="text-sm">{new Date(inv.due_date).toLocaleDateString('pt-BR')}</TableCell>
                <TableCell><StatusBadge status={inv.status} /></TableCell>
                <TableCell className="text-right">
                  <div className="flex gap-1 justify-end">
                    {inv.status === 'pendente' && (
                      <>
                        <Button variant="outline" size="sm" className="text-xs" onClick={() => toast.info('PIX gerado (placeholder)')}>
                          <QrCode className="mr-1 h-3 w-3" /> PIX
                        </Button>
                        <Button variant="outline" size="sm" className="text-xs" onClick={() => toast.info('Boleto gerado (placeholder)')}>
                          <Barcode className="mr-1 h-3 w-3" /> Boleto
                        </Button>
                      </>
                    )}
                    <Button variant="ghost" size="sm" className="text-xs">
                      <Download className="h-3 w-3" />
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
